import React from 'react';
import { axisLeft } from 'd3-axis';
import { select } from 'd3-selection';

const gridlines = ({ yScale, width, ticks }) =>
  axisLeft(yScale)
    .ticks(ticks)
    .tickSize(-width)
    .tickFormat('');

class Grid extends React.Component {
  constructor() {
    super();
    this.ref = React.createRef();
  }
  componentDidMount() {
    this.renderAxis();
  }
  componentDidUpdate() {
    this.updateAxis();
  }
  updateAxis() {
    const { t } = this.props;
    select('#grid-group')
      .transition(t)
      .call(gridlines(this.props));
  }
  renderAxis() {
    const node = this.ref.current;
    select(node).call(gridlines(this.props));
  }
  render() {
    return <g ref={this.ref} className="grid-group" id="grid-group" />;
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/components/visualization/lineChart/grid/grid.js